import {ModalController} from 'ionic-angular';
import {SessionService} from './../../../services/session';
import {TabsService} from './../tabs.service';
import {MembershipService} from './../profile/membership/membership.service';
import {MembershipPage} from './../profile/membership/membership';
import {ClassesService} from './../../../services/classes';
import {NavController, AlertController, App, NavParams} from 'ionic-angular';
import {Component, ElementRef, ViewChild} from '@angular/core';
import {FindClassPage} from '../find-class/find-class';
import {FiltersService} from '../../../services/filters';
import {AuthService} from '../../../services/auth';
import {PolicyPage} from '../../auth/policy/policy';
import {ReviewPage} from '../shared/review/review';
import {AchievementsService} from './../../../services/achievements';
import {AchievementPage} from './../my-classes/achievements/achievement/achievement';
import {PWAPushService} from './../../../services/notifications/pwa-push';
import {LocationsService} from '../../../services/locations';
import {AuthData} from '@fitpass/ionic-token-auth';
import {SignInPage} from '../../auth/sign-in/sign-in';
import { MishiService } from '../../../services/mishi';

@Component({
  selector: 'page-home',
  templateUrl: 'home.html'
})
export class HomePage {
  findClassPage = FindClassPage;
  membershipPage = MembershipPage;
  policyPage = PolicyPage;
  reviewPage = ReviewPage;
  signinPage = SignInPage;
  destroyMap = false;

  pageStatus = 'loading';
  authData: AuthData;
  url: any;
  firstLoad = true;
  homeButtonsLoaded = false;

  @ViewChild('iframe') iframeRef: ElementRef;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public classesService: ClassesService,
    public filtersService: FiltersService,
    public alertCtrl: AlertController,
    public membershipService: MembershipService,
    public tabsService: TabsService,
    public sessionService: SessionService,
    public authService: AuthService,
    public modalCtrl: ModalController,
    public PWAPushService: PWAPushService,
    public app: App,
    public achievementsService: AchievementsService,
    public mishiService: MishiService,
    public locationsService: LocationsService) {

    if (!navParams.get('dontLoad')) {

      authService
        .getUserInfo(sessionService.user.id)
        .then(() => {
          this.membershipService.getPrice().then(() => {
            this.homeButtonsLoaded = true;
          });

          this.PWAPushService.askFirebasePermission()
            .then(() => {
              this.PWAPushService.getFirebaseToken();
              this.PWAPushService.onReceiveFirebaseMessage();
            })
            .catch(err => {
              console.error(err);
            });
          if (sessionService.user.policy_version.accepted < sessionService.user.policy_version.required) {
            app.getRootNav().push(this.policyPage);
          } else if (sessionService.reservations.toReview.length > 0) {
            app.getRootNav().push(this.reviewPage);
          }
          this.achievementsService
            .getAchievements()
            .then((achievements: any) => {
              for (var category = 0; category < achievements.length; category++) {
                for (var achievement = 0; achievement < achievements[category].achievements.length; achievement++) {
                  if (achievements[category].achievements[achievement].seen === false) {
                    if (achievement === achievements[category].achievements.length - 1 ||
                      achievements[category].achievements[achievement + 1].seen !== false) {
                      let modal = this.modalCtrl.create(
                        AchievementPage,
                        {
                          achievement:
                            achievements[category].achievements[achievement]
                        },
                        {cssClass: 'smaller-modal'}
                      );
                      modal.present();
                    }
                  }
                }
              }
            })
            .catch(err => {
              this.sessionService.reportError(
                'homePage',
                'constructor() achievementsService.getAchievements()',
                err
              );
            });
        })
        .catch(err => {
          this.sessionService.reportError(
            'homePage',
            'constructor() authService.getUserInfo()',
            err
          );
        });
    }
    setTimeout(() => {
      this.destroyMap = true;
    }, 1);
  }

  ngOnInit() {
  }

  ngOnDestroy() {
    // console.log('=> HomePage ngOnDestroy');
  }

  openUrl(url: string) {
    window.open(url, '_blank');
  }

  ionViewWillEnter() {
  }

  ionViewDidEnter() {

    if (this.sessionService.user.policy_version.accepted >=
      this.sessionService.user.policy_version.required &&
      !this.sessionService.hasActiveSubscription() &&
      !this.sessionService.isSubscriptionToCancel()) {
      this.displayPopUp();
    }
    if (!('serviceWorker' in navigator)) {
      console.log('!serviceWorker');
      return;
    }

    if (!('PushManager' in window)) {
      console.log('browserNoPush');
      return;
    }
  }


  goToFindClass(activities, classType, services = [], gyms = []) {
    this.classesService.initiateClasses();
    this.classesService.loadAll(true,
      null,
      null,
      null,
      null,
      null,
      services,
      gyms,
      this.sessionService.user.city_id,
      null,
      activities);
    this.filtersService.queryParams.latitude = '';
    this.filtersService.queryParams.longitude = '';
    this.filtersService.queryParams.radius = '';
    this.filtersService.queryParams.categories = activities;
    this.filtersService.queryParams.services = services;
    this.filtersService.classType = classType;
    this.navCtrl.parent.select(this.tabsService.SEARCH);
  }

  goToMyClasses(classType) {
    console.log('goToMyClasses', classType);
    this.filtersService.myClassesType = classType;
    this.navCtrl.parent.select(this.tabsService.MY_CLASSES)
  }

  displayPopUp() {
    let title: string;
    let message: string;
    let buttonText: string;
    if (this.sessionService.user.subscription) {
      title = 'Te extrañamos';
      message = 'Te invitamos a renovar tu membresía.';
      buttonText = 'Renovar';
    } else {
      title = '¿Eres nuevo por aquí?';
      message = `${this.locationsService.translate('get')} nuestra membresía para que puedas reservar en cualquier ${this.locationsService.translate('studio')} de nuestra red.`;
      buttonText = 'Comprar';
    }
    let alert = this.alertCtrl.create({
      title: title,
      message: message,
      buttons: [
        {
          text: 'Más tarde',
          cssClass: 'black-cancel-button',
          role: 'cancel'
        },
        {
          text: buttonText,
          handler: () => {
            this.membershipService.goToMembership = true;
            this.navCtrl.parent.select(this.tabsService.PROFILE);
          }
        }
      ]
    });
    alert.present();
  }

  ionViewDidLoad() {
    window['page'] = 'HomePage'; // for GA
  }

}



// WEBPACK FOOTER //
// ./src/pages/tabs/home/home.ts